module.exports = __webpack_public_path__ + "static/media/participating universities 12.3.20.962dc172.jpg";